export interface LendingType {
  id: number;
  name: string;
  code: string;
  logoUrl: string;
  sortOrder: number;
  brokerVisible: boolean;
}

export interface AddLendingType {
  name: string;
  code: string;
}
